/**
 * Vehicle Insurance Claiming Service API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { VPError } from '../model/vPError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class InsuranceClaimingHistoryFilesViewService {

    protected basePath = 'https://localhost';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * AmsAction:GET/api/InsuranceClaimingHistoryFilesView/{repairEstimateSessionId}/history/file/{key} AmsResource:{country}/{business} 
     * @param repairEstimateSessionId 
     * @param key 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFile(repairEstimateSessionId: string, key: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getFile(repairEstimateSessionId: string, key: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getFile(repairEstimateSessionId: string, key: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getFile(repairEstimateSessionId: string, key: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (repairEstimateSessionId === null || repairEstimateSessionId === undefined) {
            throw new Error('Required parameter repairEstimateSessionId was null or undefined when calling getFile.');
        }

        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling getFile.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Blob>(`${this.basePath}/api/InsuranceClaimingHistoryFilesView/${encodeURIComponent(String(repairEstimateSessionId))}/history/file/${encodeURIComponent(String(key))}`,
            {
                // @ts-ignore
                responseType:'blob',
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
